export default __webpack_public_path__ + "static/media/pencil.f471a85f.svg";